module.exports = __webpack_public_path__ + "img/T1375_150ppi.79b6ae22.png";